export default {
  title: "Grundlagen der Programmierung",
  subtitle: "Die Grundlagen für effektive Programmierpraktiken legen",
  overviewTitle: "Kursübersicht",
  overview: `<p className="cs-m0">
              Dieser umfassende Kurs ist darauf ausgelegt, Ihnen die grundlegenden Prinzipien der Programmierung näherzubringen und dient als solide Grundlage für angehende Entwickler. Sie werden grundlegende Programmierkonzepte wie Variablen, Kontrollstrukturen, Datentypen und Algorithmen erkunden, die für das Schreiben effektiven Codes in verschiedenen Programmiersprachen unerlässlich sind.
            </p>
            <br />
            <p className="cs-m0">
              Der Lehrplan behandelt beliebte Sprachen wie Python, Java und JavaScript, sodass Sie praktische Erfahrungen im Programmieren durch praktische Übungen und Projekte sammeln können. Sie lernen, Probleme mit logischem Denken zu lösen und Algorithmen zu entwickeln, die Ihren Code auf Effizienz und Lesbarkeit optimieren.
            </p>
            <br />
            <p className="cs-m0">
              Egal, ob Sie ein absoluter Anfänger sind oder Ihre bestehenden Fähigkeiten stärken möchten, dieser Kurs wird Sie mit dem Wissen und dem Selbstvertrauen ausstatten, die erforderlich sind, um fortgeschrittenere Programmierkonzepte und Herausforderungen aus der Praxis anzugehen.
            </p>`,
};
